import { Component, OnInit } from '@angular/core';
import { CeRequestOptions } from '../../request-header/request-header.component';
import { RequestDetails, SavedRequest, RequestService, RequestDesign } from '../../../shared/services/request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RequestFormModelService } from '../../services/request-form-model.service';
import { ExperimentDetailsFormBuilderService } from '../experiment-details-form/experiment-details-form-builder.service';
import { FormGroup } from '@angular/forms';
import { ExperimentDetailsFormModel } from '../../services/request-form.service';
import { AlertService } from '../../../shared/services/alert.service';
import { LoadingWrapperService } from '../../../shared/services/loading-wrapper.service';
import { finalize, switchMap, catchError } from 'rxjs/operators';
import { CurrentUser } from '../../../shared/services/current-user.service';

@Component({
  selector: 'app-experiment-details-form-page',
  templateUrl: './experiment-details-form-page.component.html',
  providers: [
    RequestFormModelService,
    ExperimentDetailsFormBuilderService
  ]
})
export class ExperimentDetailsFormPageComponent implements OnInit {
  public options: CeRequestOptions;
  public requestDesign: RequestDesign;
  public experimentDetailsFormGroup: FormGroup;
  public currentUser: CurrentUser;
  public saving: boolean = false;
  
  private id: number;
  private requestDetails: RequestDetails;

  constructor(
    private route: ActivatedRoute,
    private formService: ExperimentDetailsFormBuilderService,
    private router: Router,
    private requestService: RequestService,
    private formModelService: RequestFormModelService,
    private alertService: AlertService,
    private loadingService: LoadingWrapperService) {
  }

  ngOnInit() {
    this.id = this.route.snapshot.params['id'];
    this.options = this.route.snapshot.data['requestOptions'];
    this.requestDetails = this.route.snapshot.data['requestDetails'];
    this.requestDesign = this.route.snapshot.data['requestDesign'];
    this.currentUser = this.route.snapshot.data['currentUser'];
    this.experimentDetailsFormGroup = this.formService.build();
    this.setupForm();
  }
  
  public save(): void {
    this.saving = true;
    this.loadingService.setMessage("Saving...");

    this.saveDetails()
      .pipe(
        switchMap(m => {
          return this.requestService.getDetails(m.id);
        }),
        catchError(e => {
          this.handleError(e, "Error getting details. Please contact support.");
          return Observable.throw(e);
        }),
        finalize(() => {
           this.loadingService.clearMessage();
           this.saving = false;
        })
      )
      .subscribe(
        r => {
          this.requestDetails = r;
          this.alertService.success("Experiment Details saved!");
        },
        e => {
          this.handleError(e, "Error saving request. Please contact support.");
        }
      );
  }

  public saveAndContinue(): void {
    this.saving = true;
    this.loadingService.setMessage("Saving...");
    
    this.saveDetails()
        .subscribe(r => {
          this.router.navigate([`/requests/edit/${r.id}/design`]);
        }, e => {
          this.saving = false;
          this.handleError(e, "Error saving request. Please contact support.");
          this.loadingService.clearMessage();
        });
  }
  
  private saveDetails(): Observable<SavedRequest> {
    const model = this.experimentDetailsFormGroup.value as ExperimentDetailsFormModel;
    const apiModel = this.formModelService.toDetailsApiModel(model);
    apiModel.id = this.id;

    return this.requestService.saveDetails(apiModel);
  }

  private setupForm(): void {
    const formModel = this.formModelService.toDetailsFormModel(this.requestDetails);

    setTimeout(() => this.experimentDetailsFormGroup
      .patchValue(formModel, { onlySelf: true, emitEvent: true }), 0);
  }
  
  private handleError(e, toastMessage: string) {
    console.error(`Status ${e.status}. ${e.message}`, "Error");
    this.alertService.error(toastMessage);
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-details/experiment-details-form-page/experiment-details-form-page.component.ts